<template>
  <div class="preview-scale">
    <Icon path="preview" name="search" />
    <PreviewProgress type="scale" @change="handleChangeScale" />
  </div>
</template>

<script>
import Icon from '@/components/icon'
import PreviewProgress from '../progress'

export default {
  name: 'PreviewScale',
  components: {
    Icon,
    PreviewProgress
  },
  data() {
    return {
      scale: 0,
      maxScale: 3
    }
  },
  watch: {
    scale(val) {
      const scale = +(1 + val * this.maxScale).toFixed(2)
      
      this.$emit('change', scale)
    }
  },
  mounted() {
    this.$topic.subscribe('preview.reset', this.reset)
  },
  methods: {
    reset() {
      this.scale = 0
    },
    handleChangeScale(scale) {
      this.scale = scale
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('~@/styles/var.less');
  .preview-scale {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    height: 40px;
    border-radius: 13px;
    user-select: none;
    background: transparent;
    .preview-progress {
      margin-left: 16px;
    }
    .i-icon-search {
      font-size: 18px;
    }
  }
</style>